<template>
    <div class="page">
        <block-with-checks></block-with-checks>
        <compare-sect-v2 background="background-grey"></compare-sect-v2>
        <old-new-way></old-new-way>
        <review></review>
        <faq-new></faq-new>
        <div class="vafrfor-section background-none">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-11">
                        <div class="titles">
                            <h5 class="med-max p-dgrey mb-0 p-bold">Varför använda TecknaEl.se?</h5>
                        </div>
                        <div class="content">
                            <p class="min-min p-black">
                                Vi hjälper översättningsbyråer, fraktleverantörer, webbyråer, betalningslösningar eller andra aktörer som vill hitta flera ehandlare som kunder. Det kan även finnas behov att hitta branschstatistik, för att säkerhetställa att det byggs rätt tjänst till en marknad där det finns potential. Det finns även möjlighet att köpa unika rapporter som är speciellt anpassade efter er frågeställning mot Sveriges ehandlare.
                            </p>
                            <p class="min-min p-black">Som abonnemangsinnehavare hos oss får ni alltid tillgång till uppdaterad data, detta är ett bra verktyg för trendbevakning och säkerhetsställa att ni agerar på rätt data. Vill ni analysera datan själva så finns det även möjlighet att med leverantörs-abonnemanget exportera datan.
                            </p>
                            <p class="min-min p-black">Strategi, trend, analys, vi hjälper er veta vilken leverantör som växer snabbast på den svenska marknaden. Detta kan spara er mycket tid, genom att rikta rätt fokus till rätt typ av kund som kan nyttja just era tjänster.
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <city-part background="background-img"></city-part>
    </div>
</template>

<script>
    import CompareSectV2 from './page-part/CompareSectV2'
    import BlockWithChecks from './page-part/BlockWithChecks'

    import OldNewWay from './page-part/OldNewWay'
    import Review from "../indexPartials/review"
    import FaqNew from './page-part/FaqNew'
    import CityPart from './page-part/cityPart'
    export default {
        name: "HomeNew",

        components: {
            CompareSectV2,
            OldNewWay,
            FaqNew,
            Review,
            CityPart,
            BlockWithChecks
        },
        created() {
            document.body.classList.add('cup');
        },
        destroyed() {
            document.body.classList.remove('cup');
        }
    }
</script>

